{
  "name": "ll-admin-fe",
  "version": "4.5.2-develop.0",
  "type": "module",
  "scripts": {
    "ng": "ng",
    "install": "cp ./package.json ./src/assets",
    "start": "ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --coverage",
    "lint": "ng lint",
    "style-lint": "stylelint \"src/**/*.scss\" --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.2.3",
    "@angular/cdk": "^22.2.3",
    "@angular/common": "^22.0.8",
    "@angular/compiler": "^22.0.8",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/material": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/platform-browser-dynamic": "^22.2.3",
    "@angular/router": "^22.0.8",
    "@eslint/js": "^10.0.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/language-service": "^22.2.3",
    "@angular/material-luxon-adapter": "^22.2.3",
    "@sparbanken-syd/auth-backend": "^2.7.1",
    "@sparbanken-syd/kalpylator": "^1.6.2",
    "@sparbanken-syd/loan-backend": "^4.10.0",
    "@sparbanken-syd/personnummer": "^3.1.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^22.0.0",
    "@sparbanken-syd/sparbanken-syd-qr": "^22.0.2",
    "@sparbanken-syd/sparbanken-syd-theme": "^22.1.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^22.0.0",
    "@sparbanken-syd/user-documents-backend": "^1.2.0",
    "@types/jmespath": "^0",
    "@types/luxon": "^3",
    "@types/node": "^24",
    "@vitest/coverage-v8": "^5.0.5",
    "angular-eslint": "^22.1.0",
    "eslint": "^10.8.0",
    "jmespath": "^0.16.0",
    "jsdom": "^30.1.3",
    "luxon": "^3.7.2",
    "postcss": "^8.5.8",
    "postcss-scss": "^4.0.9",
    "stylelint": "^17.16.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.3.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.0",
    "vite": "^8.3.5",
    "vitest": "^5.0.5"
  }
}
